import { gql } from "@grandvisionhq/graphql";
import { cartDetails } from "../../../fragments/operations/fragments/cart-details.js";
import { cartValidationErrors } from "../../../fragments/operations/fragments/cart-validation-errors.js";
const DUPLICATE_CART_LINE_ITEMS = gql`
  mutation DuplicateCartLineItems($cartInput: DuplicateCartLineItemsInput!) {
    duplicateCartLineItems(cartInput: $cartInput) {
      cart {
        ...CartDetailsFragment
      }
      validationErrors {
        ...CartValidationErrorsFragment
      }
      success
    }
  }
  ${cartDetails}
  ${cartValidationErrors}
`;
export {
  DUPLICATE_CART_LINE_ITEMS
};
//# sourceMappingURL=duplicate-cart-line-items.js.map
